if (!customElements.get('tt-downloads')) {
  customElements.define('tt-downloads', class extends HTMLElement {
    static editorSelection = new Map();

    connectedCallback() {
      if (this.controller) return;
      this.products = [...this.querySelectorAll('[data-download-product]')];
      if (!this.products.length) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.form = this.querySelector('form');
      this.input = this.querySelector('input[type="search"]');
      this.links = [...this.querySelectorAll('[data-model-link]')];
      this.select = this.querySelector('[data-model-select]');
      this.empty = this.querySelector('[data-download-empty]');
      this.status = this.querySelector('[data-download-status]');
      this.isEditor = this.dataset.designMode === 'true';
      this.searchIndex = new Map(this.products.map((product) => [product.dataset.blockId, this.normalize(`${product.dataset.modelName} ${product.dataset.keywords}`)]));
      this.allOptions = [...this.select.options];
      const savedId = this.isEditor ? this.constructor.editorSelection.get(this.id) : null;
      const initial = this.products.find((product) => product.dataset.blockId === savedId)
        || this.hashProduct()
        || this.products.find((product) => product.dataset.modelName === this.dataset.initialModel)
        || this.products[0];
      this.selectedId = initial.dataset.blockId;

      this.form.addEventListener('submit', (event) => {
        event.preventDefault();
        this.filter();
      }, options);
      this.input.addEventListener('input', (event) => {
        if (!event.isComposing) this.filter();
      }, options);
      this.input.addEventListener('compositionend', () => this.filter(), options);
      this.links.forEach((link) => link.addEventListener('click', (event) => {
        if (event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        this.selectProduct(link.dataset.modelLink, true);
      }, options));
      this.select.addEventListener('change', () => this.selectProduct(this.select.value, true), options);
      this.querySelector('[data-download-reset]').addEventListener('click', () => {
        this.input.value = '';
        this.filter();
        this.input.focus();
      }, options);
      this.products.forEach((product) => {
        product.addEventListener('change', (event) => {
          if (event.target.matches('[data-manual-choice]')) this.updateManual(product);
        }, options);
        this.updateManual(product);
      });
      window.addEventListener('hashchange', () => {
        const product = this.hashProduct();
        if (!product) return;
        this.input.value = '';
        this.selectedId = product.dataset.blockId;
        this.filter();
      }, options);
      if (this.isEditor) {
        document.addEventListener('shopify:block:select', (event) => {
          const product = this.products.find((item) => item.dataset.blockId === event.detail?.blockId);
          if (!product) return;
          this.input.value = '';
          this.selectedId = product.dataset.blockId;
          this.constructor.editorSelection.set(this.id, this.selectedId);
          this.filter();
          product.scrollIntoView({ block: 'start', behavior: 'auto' });
        }, options);
      }
      this.querySelectorAll('[data-enhanced-control]').forEach((control) => { control.hidden = false; });
      this.dataset.enhanced = '';
      this.filter();
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }

    normalize(value) {
      return value.normalize('NFKC').toLocaleLowerCase('ja').replace(/[\s/・_-]+/g, '');
    }

    hashProduct() {
      return this.products.find((product) => `#${product.id}` === window.location.hash);
    }

    filter() {
      const query = this.normalize(this.input.value);
      this.matches = this.products.filter((product) => this.searchIndex.get(product.dataset.blockId).includes(query));
      const matchedIds = new Set(this.matches.map((product) => product.dataset.blockId));
      this.links.forEach((link) => { link.hidden = !matchedIds.has(link.dataset.modelLink); });
      const options = this.allOptions.filter((option) => matchedIds.has(option.value));
      this.select.replaceChildren(...options);
      this.select.disabled = !options.length;
      if (!matchedIds.has(this.selectedId)) this.selectedId = this.matches[0]?.dataset.blockId || '';
      this.selectProduct(this.selectedId);
      this.empty.hidden = this.matches.length > 0;
      this.status.textContent = this.dataset.resultTemplate.replace('__COUNT__', String(this.matches.length));
    }

    selectProduct(id, updateHash = false) {
      const product = this.products.find((item) => item.dataset.blockId === id);
      this.selectedId = product?.dataset.blockId || '';
      this.products.forEach((item) => { item.hidden = item !== product; });
      this.links.forEach((link) => {
        if (link.dataset.modelLink === this.selectedId) link.setAttribute('aria-current', 'true');
        else link.removeAttribute('aria-current');
      });
      this.select.value = this.selectedId;
      if (this.isEditor && product) this.constructor.editorSelection.set(this.id, this.selectedId);
      if (updateHash && product && !this.isEditor) {
        const url = new URL(window.location.href);
        url.hash = product.id;
        window.history.replaceState(null, '', url);
      }
    }

    updateManual(product) {
      const downloads = [...product.querySelectorAll('[data-manual-download]')];
      const selectedIndex = product.querySelector('[data-manual-choice]:checked')?.value || downloads[0]?.dataset.manualDownload;
      const selected = downloads.find((download) => download.dataset.manualDownload === selectedIndex);
      downloads.forEach((download) => { download.hidden = download !== selected; });
      const excluded = selected?.dataset.excludeFirmware === 'true';
      const firmware = product.querySelector('[data-firmware-link]');
      if (firmware) {
        firmware.hidden = excluded;
        product.querySelector('[data-firmware-contact]').hidden = !excluded;
        product.querySelector('[data-firmware-excluded]').hidden = !excluded;
      }
    }
  });
}
